import { render, staticRenderFns } from "./quotehistory-modal.vue?vue&type=template&id=218601b6&"
import script from "./quotehistory-modal.vue?vue&type=script&lang=tsx&"
export * from "./quotehistory-modal.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports